import {memo} from 'react';
import styles from './Eyebrow.module.scss';

interface EyebrowProps {
    text: string;
    /** Render for a dark background (on-dark slate instead of the default). */
    onDark?: boolean;
    className?: string;
}

/** Plain stand-in for Common/Eyebrow: the uppercase kicker above section headings. */
const Eyebrow = ({text, onDark, className}: EyebrowProps) => (
    <p className={[styles.eyebrow, onDark && styles.onDark, className].filter(Boolean).join(' ')}>{text}</p>
);

export default memo(Eyebrow);
